module.exports = __webpack_public_path__ + "img/regm.aa415eee.png";